// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2781":"ad2974d0","2928":"b9cd72eb","3452":"ad2974d0","3807":"d1c477b0","5047":"ad2974d0","8291":"ad2974d0"}[chunkId] + ".chunk.css";
};